define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var $ = require('j');
    var device = require('util/device.util');

    module.exports = {

        init: function(widget) {
            if (widget.$el.hasClass('circular-effect')) {
                return;
            }

            widget.$el.originalAddClass('circular-effect');

            var eventName = device.formFactor === 'desktop' ? 'mousedown' : 'touchstart';
            widget.on(widget.$el, eventName, this.attachEffect.bind(this));

            if (device.formFactor !== 'desktop') {
                widget.on(widget.$el, 'touchmove', this._handleTouchMove.bind(this));
            }

        },

        offset: function(el) {
            var box = el.getBoundingClientRect();
            var docEl = document.documentElement;

            return {
                top: box.top + window.pageYOffset - docEl.clientTop,
                left: box.left + window.pageXOffset - docEl.clientLeft
            };
        },

        getSize: function(el) {
            var cs = window.getComputedStyle(el);

            return {
                height: parseFloat(cs.height) || 0,
                width: parseFloat(cs.width) || 0
            };
        },

        getDisplay: function(el) {
            return window.getComputedStyle(el).display;
        },

        _createRippleEl: function(sourceEl) {
            var rippleEl = document.createElement('span');
            rippleEl.classList.add('ripple');
            sourceEl.insertBefore(rippleEl, sourceEl.lastChild);

            return rippleEl;
        },

        _handleTouchMove: function(e) {
            this.stopAnimation(e.currentTarget);
        },

        attachEffect: function(e) {
            var el = e.currentTarget;

            //stop previous animation if double click occurred
            this.stopAnimation(el);

            var rippleEl = this._createRippleEl(el);
            var $ripple = $(rippleEl);

            var rippleSize = this.getSize(rippleEl);
            var elementSize = this.getSize(el);

            if (!rippleSize.height && !rippleSize.width) {
                //setup ripple diameter
                var d = Math.max(elementSize.width, elementSize.height);
                $ripple.css({height: d + 'px', width: d + 'px'});
                rippleSize = this.getSize(rippleEl);
            }

            //get click coordinates
            var elOffset = this.offset(el);
            var eventPosition = e.pageX ? e : e.touches && e.touches[0];
            var x = eventPosition.pageX - elOffset.left - rippleSize.width / 2;
            var y = eventPosition.pageY - elOffset.top - rippleSize.height / 2;

            //set rippleEl position
            $ripple.css({top: y + 'px', left: x + 'px'});

            // Yet another cool hack regarding fast changing of css properties bugs. See `gamesinfo.animation.js`
            // `_animateGames` method for more info.
            setTimeout(function() {
                rippleEl.classList.add('animate');
                var transitionDuration = parseFloat($ripple.css('transitionDuration')) * 1000 || 600;
                this.animationTimeout = setTimeout(this.stopAnimation.bind(this, el), transitionDuration);
            }.bind(this), 0);
        },

        stopAnimation: function(sourceEl) {
            clearTimeout(this.animationTimeout);

            // We should search .ripple among element children only, not siblings!
            var rippleEl = _.find(sourceEl.children, function(el) {
                return el.classList.contains('ripple');
            });
            rippleEl && rippleEl.remove();
        }

    };

});
